<div class="not-found">
    <img alt="menu logo" src="{{LOGO}}" class="img__logo" />
    <div class="title__container">
        <h3 class="main-title">Stranica nije pronađena</h3>
    </div>
    <p> Stranica koju si tražio nije pronađena. Vrati se na početnu stranicu ili nas kontaktiraj na
        <a href="mailto:dpo@maxbet.rs" class="e-mail">dpo&#64;maxbet.rs</a>
    </p>
    <div class="buttons">
        <button class="btn--orange"><a routerLink="/{{HOME_ROUTE}}" class="btn__text">Početna
                strana</a></button>
    </div>
</div>